import React from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { ProductFormShared } from '@/components/products/ProductFormShared';

export function ProductForm() {
  const { id } = useParams();
  const { user } = useAuth();

  if (!user) {
    return <div className="p-4">Please log in to manage products</div>;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6">
        {id ? 'Edit Product' : 'New Product'}
      </h1>
      
      <ProductFormShared 
        productId={id} 
        producerId={user.id}
        isAdmin={false}
      />
    </div>
  );
}